export const getStoreStudents = state => state.StudentReducer.students
export const getStoreTotal = state => state.StudentReducer.studentsCount